export const getTheRoute = async () => {
  const route = [
    {
      codigo: 310308,
      status: {
        text: "Em Avaliação",
        cod: 0,
        sub: "Em avaliação",
        validation: "Prazo: 24 Horas",
        adherence: "Prazo: 24 Horas",
        color: "#EE952C",
      },
      nome: "LIGACAO COMERCIAL EIRELLI",
      endereco: {
        rua: "RUA SANTO ANTONIO DO SURU",
        numero: 440,
        bairro: "SURU",
        cidade: "São Paulo",
        pais: "Brasil",
      },
      ultima_visita: "02/04/2024",
      tipo_visita: {
        text: "Presencial",
        cod: 0,
      },
      localizacao: {
        origem: {
          latitude: -22.9068,
          longitude: -43.1729,
          rua: "Rua das Palmeiras",
          numero: 1015,
          cidade: "Niterói",
          pais: "Brasil",
        },
        destino: {
          latitude: -3.07,
          longitude: -61.66,
          rua: "AV JOSE CESAR DE OLIVEIRA",
          numero: 21,
          cidade: "Amazonas",
          pais: "Brasil",
        },
      },
    },
    {
      codigo: 311422,
      status: {
        text: "Concluído",
        cod: 1,
        sub: "concluído",
        validation: "Prazo: Concluído",
        adherence: "Prazo: Concluído",
        color: "#9ACA3C",
      },
      nome: "PEDRO PINTO DE FARIA   ME",
      endereco: {
        rua: "AV JOSE CESAR DE OLIVEIRA",
        numero: 21,
        bairro: "VILA LEOPOLDINA",
        cidade: "São Paulo",
        pais: "Brasil",
      },
      ultima_visita: "20/03/2024",
       tipo_visita: {
        text: "Remota",
        cod:1
      },
      localizacao: {
        origem: {
          latitude: -23.5505,
          longitude: -46.6333,
          rua: "Rua dos Pinheiros",
          numero: 234,
          cidade: "São Paulo",
          pais: "Brasil",
        },
        destino: {
          latitude: -15.7943,
          longitude: -47.8826,
          rua: "RUA NICANOR FARIA",
          numero: 1015,
          cidade: "Rio de Janeiro",
          pais: "Brasil",
        },
      },
    },

    {
      codigo: 310314,
      status: {
        text: "Não Visitado",
        cod:3,
        sub: "Não visitado",
        validation: "Não Visitado",
        adherence: "Não Visitado",
        color: "#727272",
      },
      nome: "Julio Cesar De Oliveira",
      endereco: {
        rua: "RUA NICANOR FARIA",
        numero: 1015,
        bairro: "VILA PRESIDENTE ROOSEVELT",
        cidade: "São Paulo",
        pais: "Brasil",
      },
      ultima_visita: "06/04/2024",
       tipo_visita: {
        text: "Remota",
        cod:1
      },
      localizacao: {
        origem: {
          latitude: -12.9714,
          longitude: -38.5014,
          rua: "Avenida dos Coqueiros",
          numero: 21,
          cidade: "Rio de Janeiro",
          pais: "Brasil",
        },
        destino: {
          latitude: -24.047434,
          longitude: -46.527379,
          rua: "RUA NICANOR FARIA",
          numero: 1015,
          cidade: "Praia Grande",
          pais: "Brasil",
        },
      },
    },
    {
      codigo: 310308,
      status: {
        text: "Em Avaliação",
        cod: 0,
        sub: "Em avaliação",
        validation: "Prazo: 24 Horas",
        adherence: "Prazo: 24 Horas",
        color: "#EE952C",
      },
      nome: "LIGACAO COMERCIAL EIRELLI",
      endereco: {
        rua: "Rua Real",
        numero: 440,
        bairro: "SURU",
        cidade: "São Paulo",
        pais: "Brasil",
      },
      ultima_visita: "02/04/2024",
      tipo_visita: {
        text: "Presencial",
        cod: 0,
      },
      localizacao: {
        origem: {
          latitude: -22.9068,
          longitude: -43.1729,
          rua: "Rua das Palmeiras",
          numero: 1015,
          cidade: "Niterói",
          pais: "Brasil",
        },
        destino: {
          latitude: -3.07,
          longitude: -61.66,
          rua: "AV JOSE CESAR DE OLIVEIRA",
          numero: 21,
          cidade: "Amazonas",
          pais: "Brasil",
        },
      },
    },
    {
      codigo: 311422,
      status: {
        text: "Concluído",
        cod: 1,
        validation: "Prazo: Concluído",
        adherence: "Prazo: Concluído",
        color: "#9ACA3C",
      },
      nome: "PEDRO PINTO DE FARIA   ME",
      endereco: {
        rua: "AV JOSE CESAR DE OLIVEIRA",
        numero: 21,
        bairro: "VILA LEOPOLDINA",
        cidade: "São Paulo",
        pais: "Brasil",
      },
      ultima_visita: "20/03/2024",
       tipo_visita: {
        text: "Remota",
        cod:1
      },
      localizacao: {
        origem: {
          latitude: -23.5505,
          longitude: -46.6333,
          rua: "Rua dos Pinheiros",
          numero: 234,
          cidade: "São Paulo",
          pais: "Brasil",
        },
        destino: {
          latitude: -15.7943,
          longitude: -47.8826,
          rua: "RUA NICANOR FARIA",
          numero: 1015,
          cidade: "Rio de Janeiro",
          pais: "Brasil",
        },
      },
    },
    {
      codigo: 310314,
      status: {
        text: "Não Visitado",
        cod:3,
        sub: "Não visitado",
        validation: "Não Visitado",
        adherence: "Não Visitado",
        color: "#727272",
      },
      nome: "Julio Cesar De Oliveira",
      endereco: {
        rua: "RUA NICANOR FARIA",
        numero: 1015,
        bairro: "VILA PRESIDENTE ROOSEVELT",
        cidade: "São Paulo",
        pais: "Brasil",
      },
      ultima_visita: "06/04/2024",
       tipo_visita: {
        text: "Remota",
        cod:1
      },
      localizacao: {
        origem: {
          latitude: -12.9714,
          longitude: -38.5014,
          rua: "Avenida dos Coqueiros",
          numero: 21,
          cidade: "Rio de Janeiro",
          pais: "Brasil",
        },
        destino: {
          latitude: -24.047434,
          longitude: -46.527379,
          rua: "RUA NICANOR FARIA",
          numero: 1015,
          cidade: "Praia Grande",
          pais: "Brasil",
        },
      },
    },
    {
      codigo: 310308,
      status: {
        text: "Em Avaliação",
        cod: 0,
        sub: "Em avaliação",
        validation: "Prazo: 24 Horas",
        adherence: "Prazo: 24 Horas",
        color: "#EE952C",
      },
      nome: "LIGACAO COMERCIAL EIRELLI",
      endereco: {
        rua: "Rua Real",
        numero: 440,
        bairro: "SURU",
        cidade: "São Paulo",
        pais: "Brasil",
      },
      ultima_visita: "02/04/2024",
      tipo_visita: {
        text: "Presencial",
        cod: 0,
      },
      localizacao: {
        origem: {
          latitude: -22.9068,
          longitude: -43.1729,
          rua: "Rua das Palmeiras",
          numero: 1015,
          cidade: "Niterói",
          pais: "Brasil",
        },
        destino: {
          latitude: -3.07,
          longitude: -61.66,
          rua: "AV JOSE CESAR DE OLIVEIRA",
          numero: 21,
          cidade: "Amazonas",
          pais: "Brasil",
        },
      },
    },
    {
      codigo: 311422,
      status: {
        text: "Concluído",
        cod: 1,
        validation: "Prazo: Concluído",
        adherence: "Prazo: Concluído",
        color: "#9ACA3C",
      },
      nome: "PEDRO PINTO DE FARIA   ME",
      endereco: {
        rua: "AV JOSE CESAR DE OLIVEIRA",
        numero: 21,
        bairro: "VILA LEOPOLDINA",
        cidade: "São Paulo",
        pais: "Brasil",
      },
      ultima_visita: "02/03/2024",
       tipo_visita: {
        text: "Remota",
        cod:1
      },
      localizacao: {
        origem: {
          latitude: -23.5505,
          longitude: -46.6333,
          rua: "Rua dos Pinheiros",
          numero: 234,
          cidade: "São Paulo",
          pais: "Brasil",
        },
        destino: {
          latitude: -15.7943,
          longitude: -47.8826,
          rua: "RUA NICANOR FARIA",
          numero: 1015,
          cidade: "Rio de Janeiro",
          pais: "Brasil",
        },
      },
    },
    {
      codigo: 310314,
      status: {
        text: "Não Visitado",
        cod:3,
        sub: "Não visitado",
        validation: "Não Visitado",
        adherence: "Não Visitado",
        color: "#727272",
      },
      nome: "Julio Cesar De Oliveira",
      endereco: {
        rua: "RUA NICANOR FARIA",
        numero: 1015,
        bairro: "VILA PRESIDENTE ROOSEVELT",
        cidade: "São Paulo",
        pais: "Brasil",
      },
      ultima_visita: "06/04/2024",
       tipo_visita: {
        text: "Remota",
        cod:1
      },
      localizacao: {
        origem: {
          latitude: -12.9714,
          longitude: -38.5014,
          rua: "Avenida dos Coqueiros",
          numero: 21,
          cidade: "Rio de Janeiro",
          pais: "Brasil",
        },
        destino: {
          latitude: -24.047434,
          longitude: -46.527379,
          rua: "RUA NICANOR FARIA",
          numero: 1015,
          cidade: "Praia Grande",
          pais: "Brasil",
        },
      },
    },
  ];

  return route;
};

export const getTheRouteList = async () => {
  const client = [
    {
      description: "R$ 200,00 de bonificação disponível - Negociar volume adicional",
      action: true,
      status: "pending",
    },
    {
      description: "Sem resgate JS+ nos últimos 6M - Auxiliar a troca de pontos",
      action: true,
      status: "success",
    },
    {
      description: "Cliente elegível ao cupom impermax - Oferecer cupom em pedido",
      action: false,
      status: "refused",
    },
    {
      description: "R$ 200,00 de bonificação disponível - Negociar volume adicional",
      action: true,
      status: "pending",
    },
    {
      description: "Sem resgate JS+ nos últimos 6M - Auxiliar a troca de pontos",
      action: true,
      status: "success",
    },
  ];
  return client;
};
